// extracted by mini-css-extract-plugin
export var disabled = "_1m-a";
export var hierarchyLinkGray = "_1m-4";
export var hierarchyLinkUnderline = "_1m-3";
export var hierarchyPrimary = "_1m-0";
export var hierarchySecondary = "_1m-1";
export var hierarchyTertiary = "_1m-2";
export var pressed = "_1m-6";
export var themeAction = "_1m-5";
export var themeDestructive = "_1m-8";
export var themeNormal = "_1m-7";
export var themeSuccess = "_1m-9";